export enum DisplaySize {
  phone = 599,
  tablet = 1239,
  laptop = 1439,
  desktop = 1440,
}
